
import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  className?: string;
  setSearchOpen?: (open: boolean) => void;
  style?: React.CSSProperties;
  placeholder?: string;
}

const SearchBar = ({ searchTerm, setSearchTerm, className = "", setSearchOpen, style, placeholder = "Cerca articoli..." }: SearchBarProps) => {
  const { theme } = useThemeConfig();

  const handleClearSearch = () => {
    setSearchTerm("");
    // Don't close the search bar automatically
  };

  return (
    <div className={`relative mt-2 mb-2 ${className}`}>
      <Search
        className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4"
        style={{ color: theme.primaryColor }}
      />
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10 pr-10"
              style={{
                borderRadius: theme.cardBorderRadius,
                color: theme.primaryColor,
                backgroundColor: theme.backgroundColor
               }}      />
      {searchTerm && (
        <button
          className="absolute right-3 top-1/2 transform -translate-y-1/2"
          onClick={handleClearSearch}
          aria-label="Cancella ricerca"
        >
          <X className="h-4 w-4" style={{ color: theme.primaryColor }} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
